export default __webpack_public_path__ + "static/media/leafs.01095af4.png";